import styles from "../Content.module.scss"

import React, { useState } from "react"

import classNames from "classnames"

import { StockCounselList } from "../../../../../@shared/components"
import { useSchedule } from "../../../../../@shared/contexts"
import Schedules from "../Schedules"
import ShortForm from "../ShortForm"
import StockCounselsSearchBox from "../StockCounselsSearchBox"

const ALL_TAB = ["녹화방송", "숏폼 / AI 요약"] as const
type Tab = typeof ALL_TAB[number]

function FreeContent() {
  const { schedule } = useSchedule()
  const [selectedTab, setSelectedTab] = useState<Tab>("녹화방송")
  // 숏폼 탭 클릭할 때마다 값을 바꿔 ShortForm의 refreshTrigger로 넘겨 API를 다시 호출한다. (리마운트 아님)
  const [shortFormRefreshKey, setShortFormRefreshKey] = useState(0)

  function renderContent(_tab: Tab) {
    switch (_tab) {
      case "녹화방송": {
        return <Schedules />
      }
      case "숏폼 / AI 요약": {
        return (
          <ShortForm
            refreshTrigger={shortFormRefreshKey}
            streamerId={schedule?.user.id}
            streamerNickname={schedule?.user.nickname}
          />
        )
      }
      default: {
        return null
      }
    }
  }

  return (
    <>
      <div className={`tabB ${styles.contentTab}`}>
        {ALL_TAB.map((tab: Tab) => (
          <a
            key={tab}
            className={classNames({
              on: tab === selectedTab,
            })}
            title={tab}
            onClick={(e) => {
              e.preventDefault()

              setSelectedTab(tab)
              if (tab === "숏폼 / AI 요약") {
                setShortFormRefreshKey((key) => key + 1)
              }
            }}
          >
            {tab}
          </a>
        ))}
      </div>
      {renderContent(selectedTab)}
    </>
  )
}

export default FreeContent
